/**
 * Linki do sklepów z aplikacją kliencką MyBeautyPlace.
 *
 * Trzymane w jednym miejscu, bo prowadzą do nich zarówno landing, jak i ekrany
 * wracające z e-maili (weryfikacja adresu, reset hasła). Strona jest wyłącznie
 * wizytówką aplikacji, więc każde "co dalej" kończy się właśnie tutaj.
 */
export const APP_STORE_URL = 'https://apps.apple.com/pl/app/mybeautyplace/id6793865356?l=pl';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=pl.mybeautyplace.client&hl=pl';
export const BIZ_URL = 'https://biz.mybeautyplace.pl';
export const CONTACT_EMAIL = 'kontakt@mybeautyplace.pl';
